import { createSelector, } from 'reselect';
import { pathOr, } from 'ramda';

export const uiSelector = pathOr({}, [ 'ui', ]);

export const progressBarSelector = createSelector(
  uiSelector,
  pathOr({}, [ 'progressBar', ])
);
